var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{style:({ width: _vm.width, margin: _vm.margin }),attrs:{"size":"mini","placeholder":"请选择业务模块","clearable":"","filterable":""},on:{"change":_vm.SelectChange},model:{value:(_vm.selectValue),callback:function ($$v) {_vm.selectValue=$$v},expression:"selectValue"}},[_c('el-option',{attrs:{"label":"工单","value":"wo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }